import React, { useState } from "react";

import { Auth } from "aws-amplify";

import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import Typography from "@mui/material/Typography";

// ✅ Remplacement ici
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  root: {},
  container: {
    margin: "0 auto",
    background: "#fcfcfc",
    maxWidth: 460,
    width: "100%",
    marginTop: 120,
    borderRadius: "0px",
  },
  actions: {
    display: "flex",
    justifyContent: "space-around",
    marginTop: 0,
    padding: "10px 0",
  },
  resend: {
    display: "flex", // corrigé typo: "fley" -> "flex"
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    gap: "1rem",
  },
  error: {
    color: "red",
    marginTop: 8,
  },
});

const AuthRePassword = function (props) {
  const classes = useStyles();
  const { username, destination } = props;

  const [newPassword, setNewPassword] = useState("");
  const [code, setCode] = useState("");
  const [codeExipred, setCodeExipred] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState([]);

  const handlePasswordSubmit = async () => {
    setError([]);
    setSubmitting(true);
    try {
      await Auth.forgotPasswordSubmit(username, code, newPassword);
      setSubmitting(false);
      window.location.href = "/login";
    } catch (error) {
      setSubmitting(false);
      if (error.code?.match(/ExpiredCodeException/)) {
        setCodeExipred(true);
      }
      setError([error.message || error.code]);
    }
  };

  const handleResendCode = async () => {
    setError([]);
    try {
      setSubmitting(true);
      await Auth.forgotPassword(username);
      setCodeExipred(false);
      setSubmitting(false);
    } catch (error) {
      setSubmitting(false);
      setError([error.message || error.code]);
    }
  };

  return (
    <div className={classes.root}>
      <Card className={classes.container}>
        <CardHeader
          title="Kadomi.Shop • Validation du compte"
          subheader={`Le code de vérification a été envoyé à l'adresse ${destination}.`}
          disableTypography={true}
        />

        <CardContent>
          {codeExipred && (
            <div className={classes.resend}>
              <Typography>Le code a expiré.</Typography>
              <Button variant="contained" onClick={handleResendCode}>
                Renvoyer
              </Button>
            </div>
          )}
          <form noValidate autoComplete="off" className={classes.root}>
            <FormControl fullWidth>
              <TextField
                label="Code"
                margin="normal"
                placeholder="Code de vérification"
                onChange={(e) => setCode(e.target.value)}
                variant="outlined"
                value={code}
              />
            </FormControl>
            <FormControl fullWidth>
              <TextField
                label="Nouveau mot de passe"
                margin="normal"
                placeholder="Veuillez saisir votre mot de passe"
                onChange={(e) => setNewPassword(e.target.value)}
                variant="outlined"
                value={newPassword}
                type="password"
              />
              <Typography variant="caption">
                Le mot de passe doit comporter au moins 8 caractères, une
                minuscule, une majuscule et un chiffre.
              </Typography>
            </FormControl>
          </form>
        </CardContent>

        <CardActions className={classes.actions}>
          <Button
            variant="contained"
            disabled={
              submitting || newPassword === "" || code === "" || codeExipred
            }
            onClick={handlePasswordSubmit}
          >
            {submitting ? "processing ..." : "Envoyer"}
          </Button>
        </CardActions>
        {error.length > 0 &&
          error.map((e, key) => (
            <Typography className={classes.error} key={key}>
              {e}
            </Typography>
          ))}
      </Card>
    </div>
  );
};

export default AuthRePassword;
